import api from "@/libs/axios";
import * as ep from "../../../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    parmassins: {},
    transictionRole :{},
    loadingParmassins: false,
    loadingTransictionRole: false,
    working: false,
  },
  getters: {
    parmassins(state) {
      return state.parmassins;
    },
    loadingParmassins(state) {
      return state.loadingParmassins;
    },
    
    loadingTransictionRole(state) {
      return state.loadingTransictionRole;
    },
    working(state) {
      return state.working;
    },
    transictionRole(state){
      return state.transictionRole;
    }
  },
  mutations: {
    setParmassins(state, payload) {
      state.parmassins = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setTransictionRole(state, payload) {
      state.transictionRole = payload;
    },
  },
  actions: {
    async getParmassins(context, payload) {
      context.state.loadingParmassins = false;
      await api
        .get(ep.ROLE_BY_ID(payload.id), { params: { type: payload.slug } })
        .then((res) => {
          context.commit("setParmassins", res.data.data);
          context.state.loadingParmassins = true;
        });
    },

    async createRole({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.post(ep.ROLE, payload.data, {
          params: { type: payload.slug },
        });
        if (hasError(res.status)) {
          throw res.status;
        }
        
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },

    async updateRole({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.put(ep.ROLE_BY_ID(payload.id), payload.data, {
          params: { type: payload.slug },
        });
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },

    async deleteRole({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.delete(ep.ROLE_BY_ID(payload.id), {
          params: { type: payload.slug },
        });
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    // transictionRole
    
    async createTransictionRole({ commit }, payload) {
      commit("setWorking", true);
      console.log("payload.data" , payload.data)
      try {
        const res = await api.post(ep.TRANSICTION_ROLE, payload.data, {
          params: { type: payload.slug },
        });
        if (hasError(res.status)) {
          throw res.status;
        }
        
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    
    async deleteTransictionRole({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.delete(ep.TRANSICTION_ROLE_BY_ID(payload.id));
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    
    async getTransictionRole(context, payload) {
      context.state.loadingTransictionRole = true;
      await api
        .get(ep.TRANSICTION_ROLE_BY_ID(payload.id))
        .then((res) => {
          context.commit("setTransictionRole", res.data.data);
          context.state.loadingTransictionRole = false;
        })
        .catch(() => {
          context.commit("setTransictionRole", {});
          context.state.loadingTransictionRole = false;
        });
        
    },
    

    async updateTransictionRole({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.post(ep.TRANSICTION_ROLE_BY_ID(payload.id), payload.data , {params : {_method : 'PUT'}});
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
